<template>

   <div class="pentest-field-group">
      <label for="websiteName" class="form-label">What is the name of each website?
         <span v-if="isCreate" class="requiredField">*</span>
      </label>
      <textarea id="websiteName" class="form-control" v-model.trim="website.name" @blur="v$.website.name.$touch"
         :disabled="disableForm()"></textarea>
      <span class="form-text text-danger error-msg" v-if="v$.website.name.$error">
         Required field.
      </span>
   </div>

   <div class="pentest-field-group">
      <label for="websitePurpose" class="form-label">What is the purpose of each website?</label>
      <textarea id="websitePurpose" class="form-control" v-model.trim="website.purpose"
         :disabled="disableForm()"></textarea>
   </div>

   <div class="pentest-field-group">
      <label for="websiteURLs" class="form-label">Please provide the website URL/s.
         <span v-if="isCreate" class="requiredField">*</span>
      </label>
      <textarea id="websiteURLs" class="form-control" v-model.trim="website.url" @blur="v$.website.url.$touch"
         :disabled="disableForm()"></textarea>
      <span class="form-text text-danger error-msg" v-if="v$.website.url.$error">
         Required field.
      </span>
   </div>


   <div class="form-control pentest-field-group">
      <label class="form-label">Will this be an authenticated test with logins provided?
         <span v-if="isCreate" class="requiredField">*</span>
      </label>
      <div v-if="isCreate">
         <p class="text-muted">Authenticated tests generally provide more comprehensive and valuable results as it
            enables us to test for vulnerabilities outside and inside the website.</p>
         <div>
            <div class="form-check form-check-inline">
               <input class="form-check-input" type="radio" :value=true v-model.trim="website.isAuthenticated"
                  id="isAuthenticated" name="isAuthenticatedWebsite" :disabled="disableForm()">
               <label class="form-check-label" for="isAuthenticated">Yes</label>
            </div>

            <div class="form-check form-check-inline">
               <input class="form-check-input" type="radio" :value=false v-model.trim="website.isAuthenticated"
                  id="notAuthenticated" name="isAuthenticatedWebsite" :disabled="disableForm()">
               <label class="form-check-label" for="notAuthenticated">No</label>
            </div>

         </div>

      </div>
      <div v-else>
         <input type="text" class="form-control" id="isAuthenticated" :disabled="disableForm()"
            :value="website.isAuthenticated ? 'Yes' : 'No'" />
      </div>
   </div>

   <div class="pentest-field-group">
      <label for="webFormPageApiCount" class="form-label">How many forms, webpages and APIs are in the website?
         <span v-if="isCreate" class="requiredField">*</span>
      </label>
      <input type="text" id="webFormPageApiCount" class="form-control" v-model.trim="website.formPageApiCount"
         @blur="v$.website.formPageApiCount.$touch" :disabled="disableForm()" />
      <span class="form-text text-danger error-msg" v-if="v$.website.formPageApiCount.$error">
         Required field.
      </span>
   </div>

   <div v-if="isCreate">
      <label for="websiteRelevantFiles" class="form-label">Please provide screenshots or a list of pages and
         APIs.</label>
      <FileUploader ref="websiteRelevantFiles" :id="'websiteRelevantFiles'" @fileListChange="handleFileUpload"
         key="websiteRelevantFiles" />
   </div>

   <!-- files list -->
   <div class="pentest-field-group pentest-files-list" v-if="isView && website.relevantFiles">
      <div class="mb-2 align-items-center">
         <strong>Files provided:</strong>
         <a href="#" class="m-2 small" v-if="website.relevantFiles.length > 1 && !isDownloadingAllFiles"
            @click="downloadAllFiles('Website', this.testTypeId)" title="Click to download all available files"
            style="color:gray;">
            <i class="fa-solid fa-download pe-1"></i>
            <span>Download all files</span>
         </a>

         <span class="m-2 small" v-if="isDownloadingAllFiles" :class="{ 'd-none': !isDownloadingAllFiles }"
            style="color:gray">
            <span class="spinner-border spinner-border-sm" role="status">
               <span class="visually-hidden">Downloading files...</span>
            </span>

            <span class="m-2">Downloading files...</span>
         </span>
      </div>

      <ul class="pb-2">
         <li v-for="file in website.relevantFiles" :key="file.id">

            <div class="file-wrapper">
               <div class="pb-3 file-icon">
                  <img :src="require('@/assets/img/file_type_icons/' + getFileTypeIcon(file.file_extension))"
                     alt="File Icon" />
               </div>

               <span class="file-download-icon" title="Click to download file" @click="downloadFile('Website', file)">
                  <i class="fa-regular fa-circle-down"></i>
               </span>

               <div class="pt-3 file-name" :title="file.file_name">{{ file.file_name }}</div>
            </div>

            <span :id="file.id" :ref="file.id" class="loading d-none">
               <span class="spinner-border text-dark" role="status">
                  <span class="visually-hidden">Downloading file...</span>
               </span>
            </span>
         </li>

      </ul>
   </div>
   <!-- end -- files list -->


</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { getFileTypeIcon } from '@/plugins/helper.js'
import FileUploader from '@/components/FileUploader.vue';

// function initialState_pentestWebsite() {
//    return {
//       websiteName: '',
//       websitePurpose: '',
//       websiteUrl: '',
//       isAuthenticated: false,
//       websiteFormPageApiCount: '',
//       relevantFiles: [],
//    }
// }

export default ({

   setup() {
      return { v$: useVuelidate() }
   },

   components: {
      FileUploader,
   },

   emits: ['downloadFile', 'downloadAllFiles'],

   props: {
      items: {
         type: Object,
         // required: true,
      },

      action: {
         type: String,
         // required: true,
      },

   },

   data() {
      return {
         website: {
            name: '',
            purpose: '',
            url: '',
            isAuthenticated: false,
            formPageApiCount: '',
            relevantFiles: [],
         },
         testTypeId: '',
         isView: false,
         isCreate: false,
         isDownloadingAllFiles: false,
      }

   },

   validations() {
      return {
         website: {
            name: { required },
            url: { required },
            isAuthenticated: { required },
            formPageApiCount: { required },
         },

      }
   },

   computed: {
      itemList() {
         return this.items
      },
   },

   watch: {
      itemList() {
         this.init()
      }
   },

   created() {
      this.init()
   },

   methods: {
      init() {
         if (this.action == 'create') {
            this.createForm()
         } else {
            this.viewForm()
            this.testTypeId = this.items.test_type
            this.website.name = this.items.website.website_name
            this.website.purpose = this.items.website.website_purpose
            this.website.url = this.items.website.website_url
            this.website.isAuthenticated = this.items.website.website_is_authenticated
            this.website.formPageApiCount = this.items.website.website_form_page_api_count
            this.website.relevantFiles = this.items.website.relevant_files
         }
      },

      createForm() {
         this.isCreate = true
         this.isView = false
      },

      viewForm() {
         this.isCreate = false
         this.isView = true
      },

      resetForm() {
         this.v$.website.$reset()

         this.testTypeId = ''
         this.website.name = ''
         this.website.purpose = ''
         this.website.url = ''
         this.website.isAuthenticated = false
         this.website.formPageApiCount = ''
         this.website.relevantFiles = []

      },

      getWebPenTestDetails() {
         let website = {
            website_name: this.website.name,
            website_purpose: this.website.purpose,
            website_url: this.website.url,
            website_is_authenticated: this.website.isAuthenticated,
            website_form_page_api_count: this.website.formPageApiCount,
         }

         website.relevant_files = []
         this.website.relevantFiles.forEach((s) => {
            website.relevant_files.push({
               encoded_file: s.encoded,
               file_extension: s.extension
            })
         })

         return website
      },

      getFileTypeIcon(type) {
         return getFileTypeIcon(type)
      },

      handleFileUpload({ type, files }) {

         if (type == "websiteRelevantFiles") {
            this.website.relevantFiles = files
         }

      },

      disableForm() {
         return this.isView
      },

      downloadFile(testType, file) {
         //show loading icon
         this.$refs[file.id][0].classList.remove('d-none')
         this.$emit('downloadFile', { testType: testType, file: file })
      },

      downloadAllFiles(testType, testTypeId) {
         this.isDownloadingAllFiles = true
         this.$emit('downloadAllFiles', { testType: testType, testTypeId: testTypeId })
      },

      downloadFileDone(fileId) {
         //show loading icon
         this.$refs[fileId][0].classList.add('d-none')
      },

      downloadAllFilesDone() {
         this.isDownloadingAllFiles = false
      },
   }
})
</script>
